import React, { PureComponent } from "react";
import { BetQLSportItem } from "src/common-services";
import styles from "./styles.scss";
import AnalyticsService from "../../../../services/AnalyticsService";

interface Props {
  currentSportObj: BetQLSportItem;
  game: any;
  lineFilter: string;
  prismicGame: any;
}

/*
 * Navigation bar on the game detail page.
 * Super simple list of elements which are just stylized anchor tags that link with # tags to different parts of the game detail page.
 * In the future we'll likely want some nice scrolling effect for this rather than an instant jump but this works for now.
 */
export default class GameDetailNav extends PureComponent<Props> {
  state = {
    navElementText: "",
  };

  _trackTabClick = (tab: string) => {
    const {
      currentSportObj: { lookupKey },
      game: { id, homeTeam, awayTeam },
      lineFilter,
    } = this.props;
    this.setState({ navElementText: tab });

    AnalyticsService.track("Change Tab", {
      book: "Vegas Consensus",
      betType: lineFilter,
      sport: lookupKey,
      awayTeam: awayTeam.fullName,
      homeTeam: homeTeam.fullName,
      gameId: id,
      screen: "GameView",
      tab,
    });
  };

  render() {
    const { navElementText } = this.state;
    const { game, currentSportObj, prismicGame: doc } = this.props;

    const hasAutoPrediction = Boolean(game.analysis);
    const hasManualPrediction =
      Boolean(doc) &&
      Boolean(
        doc.intro_paragraph?.[0]?.text ||
          doc.home_team_preview?.[0].text ||
          doc.away_team_preview?.[0].text ||
          doc.full_game_prediction?.[0].text
      );

    return (
      <div className="game-detail-nav__nav-container-con">
        <div className="game-detail-nav__nav-container">
          <a
            className={`game-detail-nav__nav-el
              ${navElementText === "lines" ? "game-detail-nav__nav-el--active" : ""}`}
            href="#lines"
            onClick={() => this._trackTabClick("lines")}
          >
            Compare Lines
          </a>
          {game.projection ? (
            <a
              className={`game-detail-nav__nav-el
              ${navElementText === "model_bets" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#bets"
              onClick={() => this._trackTabClick("model_bets")}
            >
              Model Bets
            </a>
          ) : null}
          {currentSportObj.hasSharpData ? (
            <a
              className={`game-detail-nav__nav-el
                ${navElementText === "sharp-report" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#sharp-report"
              onClick={() => this._trackTabClick("sharp-report")}
            >
              Sharp Betting
            </a>
          ) : null}
          {currentSportObj.hasPlayerProps ? (
            <a
              className={`game-detail-nav__nav-el
              ${navElementText === "props" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#props"
              onClick={() => this._trackTabClick("props")}
            >
              Player Props
            </a>
          ) : null}
          {hasManualPrediction || hasAutoPrediction ? (
            <a
              className={`game-detail-nav__nav-el
              ${navElementText === "props" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#prediction"
              onClick={() => this._trackTabClick("prediction")}
            >
              Prediction
            </a>
          ) : null}
          {currentSportObj.hasTeamSummary ? (
            <a
              className={`game-detail-nav__nav-el
                ${navElementText === "team-summary" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#team-summary"
              onClick={() => this._trackTabClick("team-summary")}
            >
              Team Summary
            </a>
          ) : null}
          {currentSportObj.hasSchedule && !currentSportObj.isTennis ? (
            <a
              className={`game-detail-nav__nav-el
              ${navElementText === "schedule_summary" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#schedule"
              onClick={() => this._trackTabClick("schedule_summary")}
            >
              Schedule Summary
            </a>
          ) : null}
          {currentSportObj.key !== "XFL" ? (
            <a
              className={`game-detail-nav__nav-el
            ${navElementText === "trends_overview" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#trends"
              onClick={() => this._trackTabClick("trends_overview")}
            >
              Top Trends
            </a>
          ) : null}
          <a
            className={`game-detail-nav__nav-el
              ${navElementText === "movement" ? "game-detail-nav__nav-el--active" : ""}`}
            href="#movement"
            onClick={() => this._trackTabClick("movement")}
          >
            Line Movement
          </a>
          {currentSportObj.hasLineup && (
            <a
              className={`game-detail-nav__nav-el
                ${navElementText === "lineups" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#lineup"
              onClick={() => this._trackTabClick("lineups")}
            >
              Lineups
            </a>
          )}
          {currentSportObj.hasInjuries && (
            <a
              className={`game-detail-nav__nav-el
                ${navElementText === "injuries" ? "game-detail-nav__nav-el--active" : ""}`}
              href="#injury"
              onClick={() => this._trackTabClick("injuries")}
            >
              Injuries
            </a>
          )}
        </div>
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}
